import { FormProvider } from "react-hook-form";
import useLabInfo from "./useLabInfo";
import { Trash2 } from "lucide-react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { CustomTabList } from "@/components/CustomTabList";
import { tabs } from "./consts";
import LabInformation from "./LabInformation";
import { TaskAssignment } from "../CrmMgmt/TaskManagement";
import { MyTasks } from "@/pages/Admin";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { LOGIN_ROLES } from "@/lib/utils";

const LabInfo = () => {
  const {
    currentTab, 
    action, onTabChange
  } = useLabInfo();

  const loggedInUserData = useSelector(
      (state: RootState) => state.currentData.loggedInUserData
    );
  
    // 👇 backend sends role as array, e.g. ["CRM_HEAD"]
    const roles = loggedInUserData?.role || [];
  
    // Helper to check if user has a given role
    const hasRole = (role: string) => Array.isArray(roles) && roles.includes(role);

  return (
    <div className="px-5">
      <Tabs
        defaultValue="1"
        className="m-2"
        value={currentTab}
        onValueChange={onTabChange}
      >
        <CustomTabList
          tabs={tabs}
          className="mx-5"
          currentTab={currentTab}
          action={action}
        />

        {/* Tab 1 */}
        <TabsContent value="1" className="px-0">
          <LabInformation />
        </TabsContent>

        {/* Tab 2 → Conditional */}
        <TabsContent value="2" className="px-0 mt-20">
          <div
            style={{
              display:
                hasRole("SALES_OPS") ||
                hasRole("FINANCE_TEAM") ||
                hasRole("CRM_HEAD") ||
                hasRole("LABS_TEAM")
                  ? "block"
                  : "none",
            }}
          >
            <MyTasks />
          </div>
          <div
            style={{
              display: !(
                hasRole("SALES_OPS") ||
                hasRole("FINANCE_TEAM") ||
                hasRole("CRM_HEAD") ||
                hasRole("LABS_TEAM")
              )
                ? "block"
                : "none",
            }}
          >
            <TaskAssignment />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default LabInfo;
